import { render, staticRenderFns } from "./replacement.vue?vue&type=template&id=76cae250&scoped=true"
import script from "./replacement.vue?vue&type=script&lang=ts"
export * from "./replacement.vue?vue&type=script&lang=ts"
import style0 from "@/styles/editor.scss?vue&type=style&index=0&id=76cae250&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cae250",
  null
  
)

export default component.exports